import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicServerWhmFirewallUnblockipParamsRaw,
	LWApiPublicServerWhmFirewallUnblockipResultsRaw,
} from '@liquidweb-dev/club-sauce/public/server/whm/firewall/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { ASSET_DETAILS_QUERY_KEY } from 'modules/queries/asset/useDetails';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useServerWhmFirewallUnblockip = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicServerWhmFirewallUnblockipResultsRaw,
		ApiErrorI,
		LWApiPublicServerWhmFirewallUnblockipParamsRaw
	>({
		mutationFn: (params) => api.server.whm.firewall.apiRaw.unblockip(params),
		onSuccess: (_data, params) => {
			queryClient.invalidateQueries({
				queryKey: [ASSET_DETAILS_QUERY_KEY, { uniq_id: params.uniq_id }],
			});
		},

		onError: snackbarError,
	});
};

export default useServerWhmFirewallUnblockip;
